export default __webpack_public_path__ + "static/media/Lashes.d484c96b.svg";